import React from 'react';

import Conxus from './common/Conxus';
import SmartTouch from './common/SmartTouch';

import ImageCard from './common/ImageCard';
import Product from '../';
import VideoCard from './common/VideoCard';

const list = [
  {
    body: 'Installation is streamlined, without the time and materials cost of primary-secondary system/boiler piping.',
    heading: 'Reduce Installation Cost with Variable Flow Technology'
  },
  {
    body: 'CREST operates reliably with supply gas pressure as low as 4 inches water column. Negative regulation (neg/reg) technology draws gas into a pre-mix combustion system instead of relying on utility pressure through the gas valve. Operation is steady in low gas pressure systems or when peak gas supply demand occurs.',
    heading: 'High Efficiency with Minimum Supply Pressure'
  },
  {
    body: 'Cascade redundancy provides peace of mind because it helps ensure that a CREST boiler system will always deliver reliable performance with no downtime. Cascade sequencing can be programmed for Lead-Lag or Efficiency Optimized operation.',
    heading: 'Peace of Mind When It Matters Most'
  },
  {
    body: 'CREST offers 6 venting options, and it permits direct-vent air intake and exhaust runs up to 100 equivalent feet using PVC, CPVC, polypropylene or stainless steel pipe. Plus, multiple units can be common-vented to reduce time and materials cost.',
    heading: 'Flexible Venting Options'
  },
  {
    body: 'The patented Wave™ configuration creates turbulence as flue gas products flow down the tube, scrubbing the energy from the flue products. The Wave design enhances the life of the heat exchanger by allowing the tubes to flex so they operate stress free with none of the adverse effects suffered by traditional fire-tube boilers.',
    heading: 'Superior Fire-Tube Heat Exchanger Design'
  }
];

const videoParagraphs = [
  'With a BTU range of 750,000 to 6 million, CREST boilers have the power and installation flexibility to provide space heat in any commercial application—all while operating at up to 96.2% thermal efficiency.'
];

const Content = () => (
  <React.Fragment>
    <VideoCard
      heading="Crest"
      highlight="Condensing Boiler"
      videoUrl="https://www.youtube.com/watch?v=Hur7IZUBbKc"
      paragraphs={videoParagraphs}
    />
    <ImageCard
      heading="The First Name in"
      highlight="Efficiency"
      image="/customProduct/CrestCustomImage.png"
      list={list}
      paragraphs={[
        'CREST boilers are equipped with a top-mounted micro-metal fiber burner, engineered specifically for fire-tube technology. The system is designed to ensure smooth, quiet modulating combustion with up to 25:1 turndown. CREST is designed for efficiency to reduce your customer’s fuel bills.'
      ]}
      showDisclaimer
    />
    <Conxus />
    <SmartTouch />
  </React.Fragment>
);

const Crest = props => <Product customContent={<Content />} {...props} />;

export default Crest;
